// extracted by mini-css-extract-plugin
export default {"userCard":"styles_userCard__ZS2pf","details":"styles_details__NC36Z","img":"styles_img__ofHfD"};